import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteDisaster($id: ID!) {
        deleteDisaster(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
